// extracted by mini-css-extract-plugin
export default {"Wrapper":"Quote_Wrapper__xpctx","Max315":"Quote_Max315__Hhufg","Big":"Quote_Big__9NhUa","Title":"Quote_Title__pQtqK","Description":"Quote_Description__-xPHk"};